import { getPreventDefaultHandler, isMarkActive, toggleMark, useEditorState } from '@udecode/plate';
import * as React from 'react';

import { ToolbarButton, ToolbarButtonProps } from '../toolbar-button';

export interface ToolbarMarkProps extends Omit<ToolbarButtonProps, 'active'> {
  type: string;
  icon: React.ReactNode;
}

export const ToolbarMark = ({ type, icon, label, tooltip }: ToolbarMarkProps): JSX.Element => {
  const editor = useEditorState();

  return (
    <ToolbarButton
      active={isMarkActive(editor, type)}
      icon={icon}
      onMouseDown={getPreventDefaultHandler(toggleMark, editor, { key: type })}
      label={label}
      tooltip={tooltip}
    />
  );
};
